import React from 'react';
import { IGoodReceive } from '@/interfaces/goodReceive';
import TemplateGrHeader from './components/template-grn-header';
import TemplateGoodReceiveInfo from './components/template-gr-info';
import TemplateGrnInfoItem from './components/template-gr-info-item';
import TemplateGrnFooter from './components/template-grn-footer';

interface IProps {
  data?: IGoodReceive;
}

const TM21 = ({ data }: IProps) => {
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateGrHeader />
      <TemplateGoodReceiveInfo data={data} />
      <TemplateGrnInfoItem data={data} />
      <TemplateGrnFooter data={data} />
    </div>
  );
};

export default TM21;
